import { combineReducers } from 'redux';
import { mnuReducer } from '../menu/reducer';
import { authReducer } from '../auth/reducer';
import { websocketsReducer } from '../websockets/reducer';
import { crudReducer } from '../crud/reducer';
import { llmProfilesReducer } from 'redux/llmProfiles/reducer';
import { recordsReducer } from '../records/reducer';
import { subrecordsReducer } from '../subrecords/reducer';
import summariesReducer from '../summaries/slice';
import { saasTenantsReducer } from '../saasTenants/reducer';
import { analyticsReducer } from '../analytics/reducer';
import billingReducer from '../billing/billingSlice';

const rootReducer = combineReducers({
  menu: mnuReducer,
  auth: authReducer,
  websockets: websocketsReducer,
  crud: crudReducer,
  llmProfiles: llmProfilesReducer,
  records: recordsReducer,
  subrecords: subrecordsReducer,
  summaries: summariesReducer,
  saasTenants: saasTenantsReducer,
  analytics: analyticsReducer,
  billing: billingReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
